// @flow

import * as React from 'react';

import { Link } from 'react-router-dom';

import { useTranslator, mapTags, type TranslatorProps } from '@gandi/translate';

import withDomainContactsProps, {
  type DomainContactsProps,
  type OwnProps,
} from './withProps';

type Props = DomainContactsProps;

function getChangeLink(
  __: TranslatorProps['__'],
  changeURL: ?string,
): React.Node | string {
  return changeURL ? <Link to={changeURL}>{__('Change')}</Link> : '';
}

function getTranslation(
  __: TranslatorProps['__'],
  contactType: string,
  changeURL: ?string,
) {
  switch (contactType) {
    case 'custom':
      return mapTags(__('Custom contacts used. [[changeLink:]]'), () => ({
        changeLink: getChangeLink(__, changeURL),
      }));
    default:
      return mapTags(__('Default contacts used. [[changeLink:]]'), () => ({
        changeLink: getChangeLink(__, changeURL),
      }));
  }
}

const CellContents = ({ committed, contactType, contactsChangeURL }: Props) => {
  const { __ } = useTranslator();

  if (committed) {
    return <span>{getTranslation(__, contactType)}</span>;
  }
  return <span>{getTranslation(__, contactType, contactsChangeURL)}</span>;
};

export default (withDomainContactsProps(
  CellContents,
): React.ComponentType<OwnProps>);
